<template>
  <div class="codeInputComponent" :key="keyIndex">
    <div class="input-wrapper" v-for="item in amount" :key="item" :id="item - 1" :current="currentIndex">
      <input class="getCodeInput" type="tel" @paste="handlePaste($event)" v-focus="item - 1 === currentIndex"
        maxlength="1" @input="handleInput($event, item - 1)" @keyup.delete="onDelete($event, item - 1)"
        v-model="code[item - 1]" ref="codeInput" autofocus @blur="myBlur($event, item - 1)"
        @focus="myFocus($event, item - 1)" disabled />
    </div>
    <!--  -->
    <ShowGift :isGift="isGift" :newUserData="newUserData" @closeNewUser="closeNewUser" />
    <ChooseRecords v-if="isYearTabBox" @closeChooesRecords="closeYearBox" />
    <RegisterAfter @closeRegisterAfter="closeRegisterAfter" ref="registerAfter" />
  </div>
</template>

<script>
import { Toast } from 'vant';
import iconList from '@/utils/iconsTypes';
import { phoneLogin } from '@/api/login';
// import SelectType from '@/pages/arkHome/components/selectTypes.vue';
import { reqTypeList } from '@/api/home';
import ShowGift from '@/pages/newUserRegister/components/showGift.vue';
import { reqNowAcvitity } from '@/api/newUser';
import ChooseRecords from './chooseRecords.vue';
import RegisterAfter from './registerAfter.vue';
import { GetQueryValue, openMiniLoginCallBack, getUrlCodeFn } from '@/utils/tools';


export default {
  name: 'VerificationCodeInput',
  components: {
    // eslint-disable-next-line
    // SelectTypes,
    ShowGift,
    ChooseRecords,
    RegisterAfter,
  },
  props: {
    clearIpt: {
      type: Boolean,
      default: null,
    },
    amount: {
      type: Number,
      default: 4,
    },
    loginType: {
      type: String,
      default: null,
    },
    yuntuColor: {
      type: Boolean,
      default: false,
    }
  },
  directives: {
    focus: {
      componentUpdated(el, obj) {
        if (obj.value) el.focus();
      },
    },
  },
  data() {
    return {
      code: [],
      currentIndex: 0,
      urlParams: '',
      pagesParams: '',
      OS: '',
      keyIndex: 0,
      isYearTabBox: false,
      newData: [],
      isGift: false, // 是否展示新人注册有礼
      // haveGift: false, // 是否有新人注册活动
      newUserData: {}, // 新人注册活动数据
      pullNewPage: this.$route?.query?.redirect?.indexOf('pullnew') > -1, // 判断是否是拉新页面来的
      address: '', // 注册地址
      sourceType: 17, // 直接流量 17
      searchUrl: decodeURIComponent(window.location.search.substring(1)),
    };
  },
  watch: {
    clearIpt() {
      const { codeInput } = this.$refs;
      if (!this.clearIpt) {
        this.code = [];
        this.currentIndex = 0;

        codeInput.forEach((item, index) => {
          if (index >= 3) return;
          codeInput[index + 1].removeAttribute('class', 'activeClass');
          codeInput[index + 1].setAttribute('disabled', true);
        });
      }
    },
  },
  created() {
    this.code = new Array(this.amount).fill('');
    this.userPhone = this.$store.state.userPhone;

    this.urlParams = window.localStorage.getItem('pagesQuery');
    this.pagesParams = window.localStorage.getItem('pagesParams');

    const OS = this.getOS();
    this.OS = OS;
    this.getTypeList();
    this.getSourceType();
  },
  mounted() {
    console.log(1212,this.$route?.query?.redirect)
    const { codeInput } = this.$refs;
    setTimeout(() => {
      codeInput[0].setAttribute('class', 'activeClass');
      if (codeInput[0] && this.code[0] === '') {
        codeInput[0].removeAttribute('disabled');
        codeInput[0].focus();
      }
    }, 10);
  },

  methods: {
    // 获取分类列表
    async getTypeList() {
      const res = await reqTypeList('HOME_EXAM_CONFIG_H5');
      if (res.code === 0) {
        const navList = res.data;
        navList.map((item) => {
          // eslint-disable-next-line array-callback-return
          iconList.map((e) => {
            if (item.code === e.code) {
              Object.assign(item, e);
              // return item;
            }
          });
          return item;
        });
        this.newData = navList;
        // this.$store.dispatch('setcurrentyear', '');
      }
    },
    // 关闭选择年份弹框
    closeYearBox() {
      setTimeout(() => {
        this.isYearTabBox = false;
        // 进入新人专区页面
        this.$router.push({
          path: '/newZone',
        });
      }, 1500);

      // this.checkNewUser();
      // this.reqNewUser();
    },
    getOS() {
      // 获取当前操作系统
      let os;
      if (
        navigator.userAgent.indexOf('Android') > -1
        || navigator.userAgent.indexOf('Linux') > -1
      ) {
        os = 'Android';
      } else if (navigator.userAgent.indexOf('iPhone') > -1) {
        os = 'iOS';
      } else if (navigator.userAgent.indexOf('Windows Phone') > -1) {
        os = 'WP';
      } else {
        os = 'Others';
      }
      return os;
    },
    // 验证码自动填充
    writeGetCode(newCode) {
      const { codeInput } = this.$refs;
      codeInput.forEach((item, index) => {
        setTimeout(() => {
          codeInput[index].setAttribute('class', ' activeClass');
          codeInput[index].removeAttribute('disabled');
        });
        this.currentIndex = index;
        this.code[index] = newCode[index];
        this.keyIndex += 1;
      });
    },
    // 手机号登录
    handleInput(e, index) {
      const { codeInput } = this.$refs;
      this.currentIndex = index;
      e.target.value = this.validateNumber(e.target.value);
      // e.target.value = '8202';
      if (e.target.value?.length === 4) {
        if (e.target.value === '') return;
        document.querySelectorAll('input')[0].type = 'text';
        const reg = /(\d)(?=(?:\d{1})+\b)/g;
        const str = e.target.value;
        const newArr = str.replace(reg, '$1,');
        const arrCode = newArr.split(',');
        document.querySelectorAll('input')[0].type = 'tel';
        this.writeGetCode(arrCode);
      } else {
        if (e.target.value !== '') {
          this.currentIndex += 1;
          if (codeInput[index + 1]) {
            codeInput[index + 1].removeAttribute('disabled');
          }
        }
        codeInput[index].setAttribute('class', 'activeClass');
      }
      this.queryRequest();
    },
    dealUrlData(data) {
      const query = decodeURIComponent(window.location.search.substring(1));

      if (this.$route?.query?.free === '1') {
        this.address = query.replace(`free=1&redirect=/${data}&`, `/ark/${data}?`);
      } else {
        this.address = query.replace(`redirect=/${data}&`, `/ark/${data}?`);
      }
    },

    getSourceType() {
      const { redirect, redirctUrl } = this.$route?.query;
      console.log('redirect++++++', `/mockExam?${getUrlCodeFn(this.$route?.query?.redirctUrl, 'url')?.split('?')[1]}`)
      if (redirect?.indexOf('pullnew') > -1) {
        // 拉新活动
        this.sourceType = 1;
        this.dealUrlData('pullnew/home');
      } else if (redirect?.indexOf('receiveCoupon') > -1) {
        // 领取优惠券
        this.sourceType = 6;
        this.dealUrlData('receiveCoupon');
      } else if (redirect?.indexOf('combinationCourse') > -1) {
        // 付费课程(套餐)
        this.sourceType = 5;
        this.dealUrlData('combinationCourse');
      } else if (redirect?.indexOf('courseDetail') > -1) {
        if (this.$route?.query?.free === '1') {
          // 免费课程0元课程
          this.sourceType = 4;
        } else {
          // 付费课程
          this.sourceType = 5;
        }
        this.dealUrlData('courseDetail');
      } else if (redirect?.indexOf('drawLots') > -1) {
        // 运营活动抽奖
        this.sourceType = 2;
        if (this.$route?.query?.has === 'false') {
          this.address = this.searchUrl.replace('has=false&redirect=/drawLots', '/ark/drawLots');
        } else {
          this.address = this.searchUrl.replace('has=true&redirect=/drawLots&', '/ark/drawLots?');
        }
      } else if (redirect?.indexOf('question') > -1) {
        const questionSourceType = GetQueryValue('questionSourceType');
        if (Number(questionSourceType) === 1) {
          //  questionSourceType:
          // 1：真题实战:sourceType-20
          // 2：题库登陆:sourceType- 待定
          this.sourceType = 20;
          this.address = this.searchUrl.replace('redirect=/question/questionList&', '/question/questionList?');
        }
      } else if (redirect?.indexOf('businessOrder') > -1) {
        // 电商订单
        this.sourceType = 25;
        this.address = '/ark/businessOrder';
      } else if (redirect?.indexOf('examOutline') > -1) {
        // 电商订单
        this.sourceType = 29;
      } else if (redirect?.indexOf('collectCardIndex') > -1) {
        // 张宇集卡
        this.sourceType = 30;
        this.dealUrlData('collectCardIndex');
      } else if (redirect?.indexOf('gfxt') > -1) {
        // 估分系统
        this.sourceType = 7;
        this.dealUrlData('gfxt');
      } else if (redirect?.indexOf('iform') > -1) {
        // 自定义表单
        this.sourceType = 32;
        this.address = redirect;
      } else if (redirect?.indexOf('svipCourse') > -1 || redirect?.indexOf('svipExperienceProduct') > -1) {
        this.sourceType = 38;
      } else if (redirect?.indexOf('examInvitationHelp') > -1) {
        this.sourceType = 39;
      }
      else {
        // 直接流量
        this.sourceType = 17;
        this.address = '';
      }
    },

    async queryRequest() {
      let params;
      let result;
      if (this.code[3] !== '' && this.code.length === 4) {
        this.$refs.codeInput[3].blur();
        if (this.loginType === 'login') {
          let pullNewPageHelp = this.$route?.query?.redirect?.indexOf('help') > -1; // 判断是否是拉新落地页来的
          if (this.$route?.query?.redirect?.indexOf('helpList') > -1) {
            pullNewPageHelp = false;
          }
          // 表单过来的 不展示考级坦诚
          const miniSourceType = this.$route.query.sourceType
          params = {
            phone: this.userPhone,
            smsCode: this.code.join(''),
            loginType: 1,
            clientType: 3,
            os: this.OS,
            loginTerminal: 5,
            terminal: this.$root.miniprogram ? 6 : 5,
            sourceType: this.$root.miniprogram ? miniSourceType : this.sourceType,
            address: `${window.location.origin}${this.address}`, // 地址
            registerPlatform: this.$root.ytMini ? 25 : this.yuntuColor ? 10 : this.$root.miniprogram ? 5 : 2,
          };
          result = await phoneLogin(params);
          if (result.code === 0) {
            window.localStorage.setItem('accessToken', result.data.token);
            Toast.loading({
              type: 'success',
              duration: 1500,
              forbidClick: true,
              message: '登录成功',
            });
            this.$root.getUserInfo().then((user) => {
              if (this.$root.miniprogram) {
                openMiniLoginCallBack();
                return;
              }
              // 个人中心注册的不收集，新增 isChoose 判断
              if (result.data?.isNewUser) {
                if (this.$route.query.isChoose && !this.pullNewPage) {
                  this.isYearTabBox = true;
                } else if ((this.pullNewPage && pullNewPageHelp)) {
                  // 拉新落地页不弹23/34选择考季
                  this.$refs.registerAfter.showPop = false;
                  this.livePage();
                } else {
                  this.$refs.registerAfter.showPop = true;
                }
                // this.$refs.registerAfter.showPop = true;
                // if (this.$route.query.isChoose) {
                //   // 如果是个人中心 登录/注册按钮来的  就显示
                //   this.isYearTabBox = true;
                // } else {
                //   this.reqNewUser();
                // }
                this.send_registerSuccess_event('验证码', user.phone, user.userCode);
                this.send_loginSuccess_event('验证码登录', user.phone);
              } else {
                this.livePage();
                this.send_loginSuccess_event('验证码登录', user.phone);
              }
            });

            this.$store.dispatch('saveUserPhone', '');
            window.localStorage.removeItem('pagesQuery');
            window.localStorage.removeItem('pagesParams');
          } else {
            Toast({
              message: result?.msg,
              duration: 3 * 1000,
              position: 'top',
            });
          }
        } else if (this.loginType === 'forgetPassword') {
          this.$router.replace({
            name: 'resetPassword',
            params: { code: this.code.join(''), type: 'forgetPassword', loginSource: this.yuntuColor ? 'yuntulogin' : '' },
            query: { redirect: this.$route.query.redirect },
          });
        } else {
          Toast('登录失败，请重新操作...');
        }
      }
    },
    closeRegisterAfter() {
      if (this.pullNewPage) {
        this.livePage();
      } else if (this.$route.query.isChoose) {
        // 如果是个人中心 登录/注册按钮来的  就显示
        this.isYearTabBox = true;
      } else {
        this.reqNewUser();
      }
    },
    livePage() {
      if (
        this.$route?.query?.redirect?.indexOf('question') > -1
        || this.$route?.query?.redirect?.indexOf('cet') > -1
        || this.$route?.query?.redirect?.indexOf('mockExam') > -1 ||
        this.$route?.query?.redirect?.indexOf('gfxt') > -1 ||
        this.$route?.query?.redirect?.indexOf('iform') > -1
      ) {
        const routeUrl = this.$router.resolve({
          path: this.$route.query.redirect,
          query: JSON.parse(this.urlParams),
        });
        window.location.href = routeUrl.resolved.fullPath;
      } else if (this.$route.query.redirect) {
        this.$router.replace({
          path: this.$route.query.redirect,
          query: JSON.parse(this.urlParams),
          params: JSON.parse(this.pagesParams),
        }); // 这里是拦截前想跳转的页面
      } else {
        this.$router.replace('/home');
      }
    },
    onDelete(e, index) {
      const { codeInput } = this.$refs;
      this.code[index - 1] = '';
      if (e.target.value === '' && index !== 0) {
        this.currentIndex = index - 1;
        codeInput[index].removeAttribute('class', 'activeClass');
        codeInput[index].setAttribute('disabled', true);
      }
    },
    validateNumber(val) {
      return val.replace(/\D/g, '');
    },
    handlePaste(e) {
      e.preventDefault();
    },

    myFocus(e, index) {
      const $this = this;
      const { codeInput } = $this.$refs;

      if (this.code[0] === '') {
        codeInput[0].removeAttribute('disabled');
      }

      codeInput[index].setAttribute('class', 'activeClass');
    },

    myBlur(e, index) {
      const { codeInput } = this.$refs;
      if (e.target.value === '') {
        codeInput[index].removeAttribute('class', 'activeClass');
      }
    },
    // gio注册埋点

    /* eslint-disable */

    send_registerSuccess_event(registerMethod, mobilePhone, id) {
      gio('setUserId', id);
      let extraInfo = {}
      if (this.sourceType == 39) {
        extraInfo = {
          userSource_var: '模考邀请场',
          landingPage_var: this.$route?.query?.redirect,
        }
      }
      gio('track', 'registerSuccess_event', {
        registerMethod_var: registerMethod, // 注册方式
        mobilePhone_var: mobilePhone, // 手机号
        platform_var: 'H5',
        ...extraInfo
      });
    },
    // gio登录埋点
    // eslint-disable-next-line
    send_loginSuccess_event(loginMethod, mobilePhone) {
      gio('people.set', 'userPhone', mobilePhone);
      gio('track', 'loginSuccess_event', {
        loginMethod_var: loginMethod,
        mobilePhone_var: mobilePhone,
        platform_var: 'H5',
      });
    },
    //查询新人注册活动
    async reqNewUser() {
      const { redirect } = this.$route?.query;
      // 来源真题实战则不展示新人有礼活动
      const questionSourceType = GetQueryValue('questionSourceType');
      if (Number(questionSourceType) === 1 || redirect?.indexOf('businessOrder') > -1) {
        this.livePage();
        return
      }
      const { code, data } = await reqNowAcvitity();
      if (code === 0 && data) {
        this.isGift = true;
        // this.haveGift = true;
        this.newUserData = data;
      } else {
        this.livePage();
      }
    },
    //校验是否展示新人有礼
    // checkNewUser() {
    //   if (this.haveGift) {
    //     //有活动
    //     this.isGift = true;
    //   } else {
    //     //无活动
    //     this.livePage();
    //   }
    // },
    closeNewUser() {
      this.isGift = false;
      this.livePage();
    },
  },

  beforeDestroy() {
    clearTimeout();
  },
};
</script>

<style lang="scss" scoped>
input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 100px white inset !important;
}

input:focus,
input {
  -webkit-box-shadow: 0 0 0 #fff;
  -moz-box-shadow: 0 0 0 #fff;
  -webkit-appearance: none;
}

.codeInputComponent {
  display: flex;
  justify-content: space-around;

  input {
    width: 91px;
    height: 91px;
    color: #ff6c02;
    font-size: 35px;
    text-align: center;
    border: none;
    border: 2px solid #787878;
    border-radius: 14px;
    outline: none;
    box-shadow: 0 0 0 100px white inset;
    caret-color: #ff6c02;
  }

  input[type='number']:focus,
  .activeClass {
    border: 2px solid #ff6c02;
    border-radius: 14px;
    outline: none;
  }
}
</style>
